import React from 'react';
import { IconProps } from '.';

type VisaIconProps = {} & IconProps;

export const VisaIcon: React.FC<VisaIconProps> = ({
  width = 51,
  height = 16,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 51 17"
    >
      <path
        fill="#172B85"
        fillRule="evenodd"
        d="M12.73 16.61H8.325L5.019 3.623c-.157-.597-.49-1.125-.98-1.374C2.817 1.623 1.47 1.126 0 .874v-.5h7.1c.979 0 1.714.752 1.836 1.624l1.715 9.368L15.055.374h4.285L12.73 16.61zm9.06 0h-4.163L21.054.374h4.162L21.79 16.61zM30.6 4.872c.123-.874.858-1.374 1.715-1.374 1.348-.126 2.815.125 4.04.749L37.09.75A10.265 10.265 0 0033.294 0c-4.04 0-6.979 2.249-6.979 5.37 0 2.375 2.082 3.621 3.552 4.372 1.59.75 2.202 1.25 2.08 1.998 0 1.124-1.225 1.624-2.447 1.624-1.47 0-2.94-.375-4.285-1l-.735 3.498c1.47.623 3.06.874 4.53.874 4.529.123 7.344-2.123 7.344-5.496 0-4.246-5.754-4.495-5.754-6.368zM50.92 16.61L47.616.374h-3.55c-.735 0-1.47.5-1.715 1.25L36.233 16.61h4.285l.855-2.372h5.264l.49 2.372h3.794zM44.678 4.747l1.223 6.119h-3.427l2.205-6.12z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
